var url = document.URL;
var arr = url.split('#tab-');
var tabId = arr[1];
var tabIdInt = parseInt(tabId);
var allTabs = document.querySelectorAll(".customer-tab-name");
var allTabsContent =  document.querySelectorAll(`.customer-block-each`);

if (window.location.href.indexOf("tab") > -1) {
  document.querySelector(`#tab-${tabIdInt}`).classList.add("active");
  document.querySelector(`#tab-content-${tabIdInt}`).style.display = "block";
  document.querySelector(`#tabone-${tabIdInt} .accordion-heading`).classList.add("active");
  document.querySelector(`.customer-service-wrap`).classList.add("scroll-animate");
}
else {
  allTabs[0].classList.add("active");
  allTabsContent[0].style.display = "block";
}

if( allTabs.length > 0 ) {
  allTabs.forEach((toggler) => {
    toggler.addEventListener('click' , () => {
      const target = toggler.dataset.name;
      document.querySelectorAll('.customer-tab-name').forEach( elem => elem.classList.remove("active"));
      document.querySelector(`#tab-${target}`).classList.add("active");
      document.querySelectorAll(`.customer-block-each`).forEach( elem => elem.style.display = "none");
      document.querySelector(`#tab-content-${target}`).style.display = "block";
    })
  });
}

$(document).ready(function(){
  // Add 'active' class to the first .accordion-heading element
  $('.customer-inner-list:first-child .accordion-heading').addClass("active").next(".answer").slideDown();

  // Handle click event
  $('.customer-accordion > .customer-inner-list .accordion-heading').click(function() {
        // Toggle 'active' class and slide
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").next(".answer").slideUp();
    } else {
      // Remove 'active' class from all other elements
      // $('.customer-accordion > .customer-inner-list .accordion-heading').removeClass("active").next(".answer").slideUp();
      $(this).addClass("active").next(".answer").slideDown();
    }
    
    return false;
  });
  $('.customer-service-wrap .swiper-button-prev').addClass('swiper-button-disabled');
});

$(document).ready(function(){
  // Add 'active' class to the first .accordion-heading element
  $('.customer-inner-list:first-child .accordion-heading').addClass("active").next(".answer").slideDown();

  // Handle click event
  $('.product-ingredients__sidebar-body > .customer-inner-list .accordion-heading').click(function() {
    // Toggle 'active' class and slide
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").next(".answer").slideUp();
    } else {
      // Remove 'active' class from all other elements
      $('.product-ingredients__sidebar-body > .customer-inner-list .accordion-heading').removeClass("active").next(".answer").slideUp();
      $(this).addClass("active").next(".answer").slideDown();
    }
    
    return false;
  });

  // Tabs FAQ Accordion 
  $('.products-tabs-faq:first-child .collapsible-row--toggle').addClass("active").next(".answer").slideDown();
  $('.products-tabs-faq .collapsible-row--toggle').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").next(".answer").slideUp();
    } else {
      $('.products-tabs-faq .collapsible-row--toggle').removeClass("active").next(".answer").slideUp();
      $(this).addClass("active").next(".answer").slideDown();
    }
    return false;
  });

  // View full ingredients mobile accordion
  $('.ingredients-drawer .customer-inner-list:first-child .accordion-heading-mobile').addClass("active").next(".answer-mobile").slideDown();
  $('.ingredients-drawer .customer-inner-list .accordion-heading-mobile').click(function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active").next(".answer-mobile").slideUp();
    } else {
      $('.ingredients-drawer .customer-inner-list .accordion-heading-mobile').removeClass("active").next(".answer-mobile").slideUp();
      $(this).addClass("active").next(".answer-mobile").slideDown();
    }
    return false;
  });

});

var Swipes = new Swiper('.product-tab__ingredientsSlider', {
  loop: false,
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  pagination: {
      el: '.swiper-pagination',
      clickable: true
  },
  breakpoints: {
    1920: {
      slidesPerView: 3.1,
      spaceBetween: 30
    },
    768: {
      slidesPerView: 3.2,
      spaceBetween: 30
    },
    280: {
      slidesPerView: 1.8,
      spaceBetween: 20
    }
  }
});

// Product ingredients sidebar
var sidebar_open_button = document.querySelectorAll('[data-toggle-product-ingeridants]');
var sidebar_close_button = document.querySelectorAll('[data-product-ingeridant-close]');

for(var i=0; i<sidebar_open_button.length; i++){
  if(sidebar_open_button[i] != null){
    sidebar_open_button[i].addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.add('show_product_ingeridants');
    });
  }
}

for(var j=0; j<sidebar_open_button.length; j++){
  if(sidebar_close_button[j] != null){
    sidebar_close_button[j].addEventListener('click', function(e){
      e.preventDefault();
      document.body.classList.remove('show_product_ingeridants');
    });
  }
}

// Function to handle click events on the body
function bodyClickHandler(event) {
  // Check if the clicked element is not includeOpenButton, includeCloseButton, or inside the .clearRoutine__sidebar
  if (!event.target.closest('[data-toggle-product-ingeridants]') && !event.target.closest('[data-product-ingeridant-close]') && !event.target.closest('.product-ingredients__sidebar')) {
    // Remove the 'show__include' class from the body
    document.body.classList.remove('show_product_ingeridants');
  }
}

// Add event listener to the body to listen for click events
document.body.addEventListener('click', bodyClickHandler);

var detailsElements = document.querySelectorAll('.product-ingredients__sidebar-body details');
detailsElements.forEach(details => {
  details.addEventListener('click', () => {
    setTimeout(() => {
      details.setAttribute('open', 'open');
      detailsElements.forEach(d => {
        if (d !== details) {
          d.removeAttribute('open');
        }
      });
      details.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 200);
  });
});
